<template>
  <page-outline :title="'Détails de la vérification'">
    <template slot="pageContent">
      <spinner v-if="activateSpinner"></spinner>
      <div v-else>
        <b-row>
          <b-col sm="6" style="border-right:1px solid lightgrey;">
            <form-accordion :title="'Données de l\'entreprise'">
              <b-row class="justify-content-start">
                <b-col sm="6" class="form-group">
                  <span>{{ $t('suppliers.supplier_id') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ siren }}</span>
                </b-col>
                <b-col sm="6" class="form-group">
                  <span>{{ $t('common.social_reason') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ socialReason }}</span>
                </b-col>
              </b-row>
              <b-row class="justify-content-start">
                <b-col sm="6" class="form-group">
                  <span>{{ $t('common.dt_crtn') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ dateCreation }}</span>
                  <br/>
                  <span>{{ $t('suppliers.legal_status') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ legalForm }}</span>
                </b-col>
                <b-col sm="6" class="form-group">
                  <span>{{ $t('suppliers.core_business') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ coreBusiness }}</span>
                </b-col>
              </b-row>
              <!-- <b-row class="justify-content-start">
                <b-col sm="12" class="form-group">
                  <span>{{ $t('suppliers.supplier_person') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ firstName + ' ' + lastName }}</span>
                </b-col>
              </b-row> -->
            </form-accordion>
          </b-col>

          <!-- border:1px solid lightgrey;border-radius:10px;padding-top:10px; -->
          <b-col sm="6" style="">
            <form-accordion :title="'Données de l\'établissement'">
              <b-row>
                <b-col sm="6" class="form-group">
                  <span>{{ $t('suppliers.supplier_siret') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ siret }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="12" class="form-group">
                  <span>{{ $t('common.adrs') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ address }}</span>
                </b-col>
              </b-row>
              <b-row>
                <b-col sm="6" class="form-group">
                  <span>{{ $t('common.zp_code') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ postalCode }}</span>
                </b-col>
                <b-col sm="6" class="form-group">
                  <span>{{ $t('common.cty') + ' : ' }}</span>
                  <span class="font-weight-bold">{{ town }}</span>
                </b-col>
              </b-row>
            </form-accordion>
          </b-col>
        </b-row>

        <hr v-if="entity.getUBOs" />
        <form-accordion :title="'Bénéficiaires effectifs'"
          v-if="entity.getUBOs">
          <b-row v-if="ubos.length" class="justify-content-start">
            <b-col sm="6" class="form-group"
              v-for="(ubo, index) in ubos" :key="index">
              <f7-icon fa="user" v-if="ubo.Type === 'PP'"></f7-icon>
              <f7-icon fa="building" v-if="ubo.Type === 'PM'"></f7-icon>
              {{ ubo.LastName }}
              {{ ubo.FirstName }}
              {{ ubo.PercentageDetention + '%' }}
            </b-col>
          </b-row>
        </form-accordion>

        <!-- <hr/>
        <form-accordion :title="'Derniers actes'">
          <b-row class="justify-content-start">
            <b-col sm="4" class="form-group">
              <p>Dépot n° 99999999 du 15/10/2021</p>
              <p>07/10/2021	STATUTS MIS A JOUR (19 pages)</p>
            </b-col>
            <b-col sm="2" class="form-group">
              <f7-button round
                class="button-action milkyBlockBlack"
                @click="callInstitutionalSource('2017-07-06')">
                {{ 'Télécharger' }}
              </f7-button>
            </b-col>
          </b-row>
        </form-accordion> -->

        <hr/>
        <form-accordion :title="'Vérifications'">
          <b-table hover bordered head-variant="light"
            class="resultsVerifications"
            :items="verificationsItems"
            :fields="verificationsFields"
            :sort-by="'id'">
            <template #cell(result)="data">
              <div class="text-center">
                <i class="icon list-icon icon-error" v-if="data.value === 'KO'"></i>
                <i class="icon list-icon icon-warning" v-else-if="data.value === 'WARN'"></i>
                <i class="icon list-icon icon-information" v-else-if="data.value === 'INFO'"></i>
                <i class="icon list-icon icon-ok" v-else></i>
              </div>
            </template>
          </b-table>
        </form-accordion>
      </div>
    </template>
  </page-outline>
</template>

<script>
import FormAccordion from '@/components/common/FormAccordion.vue'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import PageOutline from '@/components/common/PageOutline.vue'
import spinner from '@/components/common/spinner.vue'

import {errorMessageAlert} from '@/helpers/alert'

export default {
  name: 'VerificationsDetailPage',
  components: {
    'form-accordion': FormAccordion,
    'form-read-group-label-input': formReadGroupLabelInput,
    'page-outline': PageOutline,
    'spinner': spinner
  },
  data () {
    return {
      activateSpinner: true,
      address: '',
      coreBusiness: '',
      coreBusinessCode: '',
      coreBusinessLabel: '',
      dateCreation: '',
      entity: {},
      firstName: '',
      lastName: '',
      legalForm: '',
      postalCode: '',
      siren: '',
      siret: '',
      socialReason: '',
      town: '',
      ubos: [],
      verificationsFields: [
        { key: 'control', label: 'Contrôle', thStyle: { width: '200px' } },
        { key: 'result', label: 'Résultat', thStyle: { width: '50px' } },
        { key: 'details', label: 'Détails', thStyle: { width: '400px' } }
      ],
      verificationsItems: []
    }
  },
  created () {
    this.entity = this.$engine.services.suppliers.selectedEntity
    this.address = ''
    let addressElements = ['StreetNumber', 'StreetNumberRepetition', 'StreetType', 'StreetName']
    for (let indexElement in addressElements) {
      let element = addressElements[indexElement]
      if (this.entity[element]) {
        if (this.address === '') {
          this.address += this.entity[element]
        } else {
          this.address += ' ' + this.entity[element]
        }
      }
    }
    this.coreBusinessCode = this.entity.ActivityUnit || this.entity.NAFCode
    this.coreBusinessLabel = this.entity.ActivityLabel || this.entity.NAFLabel
    if (this.coreBusinessCode && this.coreBusinessLabel) {
      this.coreBusiness = this.coreBusinessLabel + ' (' + this.coreBusinessCode + ')'
    }
    this.dateCreation = this.entity.CreationDateUnit || this.entity.RegistrationDate
    this.firstName = this.entity.FirstName || this.entity.LegalRepresentativeFirstname
    this.lastName = this.entity.LastName || this.entity.LegalRepresentativeLastname
    this.legalForm = this.entity.LegalCategoryLabel || this.entity.LegalForm
    this.postalCode = this.entity.PostalCode || this.entity.ZipCode
    this.siren = this.entity.SIRENUnit || this.entity.Siren
    this.siret = this.entity.SIRET || this.entity.Siret
    if (this.entity.Denomination) {
      this.socialReason = this.entity.Denomination
    } else if (this.entity.SocialReason) {
      this.socialReason = this.entity.SocialReason
    } else if (this.entity.UsualDenomination) {
      this.socialReason = this.entity.UsualDenomination
      if (this.entity.Sign1) {
        this.socialReason += ' (' + this.entity.Sign1 + ')'
      }
    } else if (this.entity.FirstName1 && this.entity.FirstName2) {
      this.socialReason = this.entity.FirstName1 + ' ' + this.entity.FirstName2
    } else {
      this.socialReason = ''
    }
    this.town = this.entity.TownName || this.entity.City
    if (this.entity.getUBOs) {
      this.callUBOinstitutionalSource('318334463')
    }
    if (this.entity.verify) {
      this.verifyCompany()
    } else {
      this.setControls()
    }
  },
  methods: {
    callInstitutionalSource (dateDepot) {
      let dateDepotGet = dateDepot.replaceAll('-', '')
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      let params = {
        Siren: this.entity.Siren,
        DocType: 'STATUS',
        DateDepotGet: dateDepotGet
      }
      this.$engine.services.suppliers.getDocumentFromInstitutionalSource(params)
      .then(response => {
        if (response.status === 200) {
          this.$f7.hidePreloader()
          let linkSource = response.data.DocumentData
          let downloadLink = document.createElement('a')
          let fileName = response.data.DocumentName

          downloadLink.href = linkSource
          downloadLink.download = fileName
          downloadLink.click()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    callUBOinstitutionalSource (siren) {
      this.$f7.showPreloader(this.$i18n.t('loading.asking_instit'))
      // let params = {
      //   Siren: siren,
      //   RepeatOnlyPP: '1',
      //   SaveDatabase: '0'
      // }
      let that = this
      that.ubos = [
        {
          Type: 'PP',
          LastName: 'COUSIN',
          FirstName: 'Valérie',
          PercentageDetention: '50'
        },
        {
          Type: 'PP',
          LastName: 'BONNET',
          FirstName: 'XAVIER',
          PercentageDetention: '50'
        }
      ]
      that.$f7.hidePreloader()
      // this.$engine.services.suppliers.getUBOFromInstitutionalSource(params)
      // .then(response => {
      //   if (response.status === 200) {
      //     that.$f7.hidePreloader()
      //     if (response.data.Beneficial != null) {
      //       that.ubos = response.data.Beneficial
      //     }
      //   }
      // })
      // .catch(error => {
      //   errorMessageAlert(error, that)
      // })
    },
    setControls () {
      let registreKO = false // temporaire
      for (var i = 0; i < this.entity.CodeList.length; i++) {
        let code = this.entity.CodeList[i].Code || this.entity.CodeList[i].code
        let details = this.entity.CodeList[i].Reason || this.entity.CodeList[i].reason
        if (details) {
          details = details.replace(/\. /g, '.\r\n')
          details = details.replace(/###/g, '\r\n\r\n')
        }
        if (code === '00000') {
          this.verificationsItems.push({ id: 0, control: 'Format du SIREN', result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '01001') {
          this.verificationsItems.push({ id: 1, control: 'Etat administratif de l\'entreprise', result: 'OK', details: details })
        } else if (code === '01000') {
          this.verificationsItems.push({ id: 1, control: 'Etat administratif de l\'entreprise', result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '01011') {
          this.verificationsItems.push({ id: 2, control: 'Etat administratif de l\'établissement', result: 'OK', details: details })
        } else if (code === '01010') {
          this.verificationsItems.push({ id: 2, control: 'Etat administratif de l\'établissement', result: 'KO', details: details, _rowVariant: 'danger' })
        }


        if (code === '14001') {
          this.verificationsItems.push({ id: 3, control: 'Activité autorisée', result: 'OK', details: details })
        } else if (code === '14000') {
          this.verificationsItems.push({ id: 3, control: 'Activité autorisée', result: 'KO', details: details, _rowVariant: 'danger' })
        }

        if (code === '12001' || code === '12030') {
          this.verificationsItems.push({ id: 4, control: 'Procédure judiciaire', result: 'OK', details: details })
        } else if (code === '12000') {
          this.verificationsItems.push({ id: 4, control: 'Procédure judiciaire', result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '03001') {
          this.verificationsItems.push({ id: 5, control: 'Validité du numéro de TVA', result: 'OK', details: details })
        } else if (code === '03000') {
          this.verificationsItems.push({ id: 5, control: 'Validité du numéro de TVA', result: 'WARN', details: 'Le numéro de TVA intracommunautaire n\'a pas été trouvé', _rowVariant: 'warning' })
        }

        if (code === '10011' || code === '10021') {
          this.verificationsItems.push({ id: 6, control: 'Inscription au registre', result: 'OK', details: details })
        } else if (code === '10010' || code === '10020' || code === '10030') {
          registreKO = true
          this.verificationsItems.push({ id: 6, control: 'Inscription au registre', result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '11011') {
          this.verificationsItems.push({ id: 7, control: 'Statuts disponibles', result: 'OK', details: details })
        } else if (code === '11010') {
          this.verificationsItems.push({ id: 7, control: 'Statuts disponibles', result: 'WARN', details: details, _rowVariant: 'warning' })
        }

        if (code === '13001') {
          this.verificationsItems.push({ id: 8, control: 'Stabilité de l\'entreprise', result: 'OK', details: details })
        } else if (code === '13000') {
          this.verificationsItems.push({ id: 8, control: 'Stabilité de l\'entreprise', result: 'WARN', details: details, _rowVariant: 'warning' })
        }
      }
      if (registreKO) {
        this.verificationsItems = this.verificationsItems.filter(function (obj) {
          return obj.id !== 7
        })
      }
      this.activateSpinner = false
    },
    verifyCompany () {
      let that = this
      this.$f7.showPreloader(this.$i18n.t('loading.loading_general'))
      let params = {
        siret: this.siret
      }
      this.$engine.services.verifications.verifyCompany(params)
      .then(response => {
        if (response.status === 200) {
          that.$f7.hidePreloader()
          that.entity.CodeList = response.data.controls
          that.setControls()
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    }
  }
}
</script>

<style>
.resultsVerifications td {
  white-space: break-spaces;
}
</style>



// WEBPACK FOOTER //
// VerificationsDetailPage.vue?71c52a9d